export const indexStateData = {
  loading: false,
  error: false,
  success: false,
  message: "",
  accessToken: null,
  analytics: false,
};

export const menuStateData = {
  index: 1,
};

export const initialproductOffers = {
  productOffers: [],
  changedOffer: {},
  offerValue: {},
};
